import {minThresholdMap} from './constants';
import {SubscriberEngagementRecapStatsType, type SubscriberEngagementRecapStats} from './types';

type SubscriberEngagementRecapInput = {
    [K in keyof SubscriberEngagementRecapStats]?: SubscriberEngagementRecapStats[K] | null;
};

export const getSubscriberEngagementRecapStats = (
    recap?: SubscriberEngagementRecapInput | null,
): SubscriberEngagementRecapStats => {
    if (!recap) return {};
    return Object.fromEntries(
        Object.values(SubscriberEngagementRecapStatsType).flatMap((field) => {
            const value = recap[field];
            const numericValue = Array.isArray(value) ? value.length : value;

            if (typeof numericValue !== 'number' || numericValue < minThresholdMap[field])
                return [];

            return [[field, value]];
        }),
    );
};
